/* @flow */

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import Form from 'forms/_.extend';

//----------------------------------------------------------------------//
// FORM SETUP
//----------------------------------------------------------------------//

const baseModelCalc: Function = (field: Object) => {
  const model = field.state.form.select('productAddition.model').value;
  const scode = field.state.form.select('productAddition.shortCode').value;

  if (model && scode) {
    field.state.form.update({
      productAddition: {
        base_model: `${scode}${model}`,
      },
    });
  } else {
    field.state.form.update({
      productDetail: {
        base_model: '',
      },
    });
  }
};

export const setupProductAdditionRequest: Function = (
  action: Object,
  notification: Object,
  handleSubmit: Function,
  onSuccess: Function,
  t: Function
) => {
  const fields: Array<Object> = [
    {
      name: 'productAddition',
      label: t('general:product'),
      fields: [
        {
          name: 'manufacturer_name',
          label: t('general:manufacturer'),
          placeholder: t('general:manufacturer'),
          rules: 'required|string',
          value: action.fields.manufacturer_name,
          extra: {
            selectID: action.fields ? action.fields.manufacturer_id : null,
            toggleToDisable: true,
            resetValue: (action && action.fields) || null,
            resetValueFields: [
              {
                field: 'manufacturer_name',
                value: 'manufacturer_name',
              },
            ],
            toggleToTextField: true,
            isTextField: true,
            textTitle: 'Choose existing',
            title: 'Use original',
            buttonClick: 'model',
            setSelectedFields: [
              {
                field: 'model',
                value: null,
              },
            ],
          },
        },
        {
          name: 'model',
          label: t('general:model'),
          placeholder: t('general:model'),
          rules: 'required|string',
          value: action.fields.model,
          extra: {
            selectID: action.fields ? action.fields.product_id : null,
            parentId: action.fields ? action.fields.manufacturer_id : null,
            resetValue: (action && action.fields) || null,
            resetValueFields: [
              {
                field: 'model',
                value: 'model',
              },
              {
                field: 'base_model',
                value: 'base_model',
              },
              {
                field: 'product_group_description',
                value: 'product_group_description',
              },
              {
                field: 'fair_market_value',
                value: 'fair_market_value',
              },
            ],
            toggleToTextField: true,
            isTextField: true,
            textTitle: 'Choose existing',
            title: 'Use original',
            buttonClick: 'manufacturer_name',
            setSelectedFields: [
              {
                field: 'model',
                value: 'model',
              },
              {
                field: 'base_model',
                value: 'base_model',
              },
              {
                field: 'product_group_description',
                value: 'product_group_description',
              },
              {
                field: 'fair_market_value',
                value: 'fair_market_value',
              },
            ],
          },
          hooks: {
            onChange(field) {
              baseModelCalc(field);
            },
          },
        },
        {
          name: 'base_model',
          label: t('general:products.labels.base_model'),
          placeholder: t('general:products.labels.base_model'),
          rules: 'string',
          value: action.fields.base_model
            ? action.fields.base_model
            : `${action.fields.manufacturer_short_code}${action.fields.model}`,
        },
        {
          name: 'product_group_description',
          label: t('general:assets.labels.model_description'),
          placeholder: t('general:assets.labels.model_description'),
          rules: 'required|string',
          value: action.fields.product_group_description,
        },
        {
          name: 'fair_market_value',
          label: t('general:labels.fair_market_value'),
          placeholder: t('general:labels.fair_market_value'),
          rules: 'numeric',
          value: action.fields.fair_market_value,
        },
        {
          name: 'shortCode',
          value: action.fields.manufacturer_short_code || null,
          rules: 'string',
        },
        {
          name: 'inEditMode',
          value: null,
        },
      ],
    },
  ];

  const hooks: Object = {
    onSuccess(data: Object) {
      let values: Object = data.values().productAddition;
      values = {
        ...values,
        event_parent_id: action.fields.event_parent_id,
        manufacturer_id: data.$('productAddition.manufacturer_name').extra.selectID,
        product_id: data.$('productAddition.model').extra.selectID,
        activity_tag: 'add_product',
        status: 'Approved',
      };

      const myAction = values.inEditMode
        ? notification.actions.find((act: Object) => act.type === 'merge')
        : notification.actions.find((act: Object) => act.type === 'approve');

      if (values.inEditMode) {
        myAction.endpoint = myAction.endpoint.replace(
          '{product_id}',
          data.$('productAddition.model').extra.selectID
        );
        values.product_id = myAction.fields.product_id;
      }

      delete values.inEditMode;
      handleSubmit(myAction, notification.template_values, values, onSuccess);
    },
  };

  return new Form(
    { fields },
    {
      hooks,
      name: 'productAdditionRequest',
    }
  );
};
